import React from 'react';
import { Avatar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Box } from '@mui/material';
import { CustomAccordion } from '../../../shared';
import { CHANNEL_COLUMNS, CHANNELS_DATA } from './constants';
import { partnersLogo } from '../../../../assets/partners';

const tableComponent = (CHANNEL, TABLE_DATA, handleModal) => (
    <TableContainer component={Paper}>
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell className="flex-row-start-center gap-8 text-lg-medium gray-900 no-border" colSpan={5}>
                        {CHANNEL}
                    </TableCell>
                </TableRow>
                <TableRow>
                    {CHANNEL_COLUMNS.map((column, index) => (
                        <TableCell
                            className="text-xs-medium gray-500 bg-gray-50"
                            key={index}
                        >
                            {column}
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {TABLE_DATA?.map((row, index) => (
                    <TableRow key={index} onClick={handleModal}>
                        <TableCell className="text-sm-medium gray-900 w-25">
                            <Box className="flex-row-align-items-center gap-12">
                                <Avatar
                                    alt={row.vendor}
                                    height="40px"
                                    src={partnersIconMapping(row.vendor)}
                                    width="40px"
                                />
                                {row.vendor}
                            </Box>
                        </TableCell>
                        <TableCell className="text-sm-regular gray-500">{row.sent}</TableCell>
                        <TableCell className="text-sm-regular gray-500">{row.engaged}</TableCell>
                        <TableCell className="text-sm-regular gray-900">{row.cost}</TableCell>
                        <TableCell className="text-sm-regular primary-700">
                            <Box className="flex-row-center br-16px primary-700 bg-primary-50 padding-tb-2-rl-10 w-fit-content">
                                {row.roi}
                            </Box>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
);

const tableComponents = (handleModal) => {
    const tableComponents = [];
    for (const CHANNEL in CHANNELS_DATA) {
        tableComponents.push(tableComponent(CHANNEL, CHANNELS_DATA[CHANNEL], handleModal));
    }

    return tableComponents;
};

const partnersIconMapping = (name) => {
    const partner = name?.toLowerCase();
    return partnersLogo[partner] || ' ';
};

const OverallImpactAnalysis = () => (
    <CustomAccordion 
        accordionContainerBackground="bg-white" 
        acoordianDetailsBackground='bg-white' 
        component={tableComponents()}
        title="Channel Impact Analysis"
    />
);

export default OverallImpactAnalysis;